import { useContext, useEffect } from "react";
import "../src/styles/ThirdStep.scss";
import { FormContext } from "./AppForm";
import { useTranslation, Trans } from "react-i18next";
import PhoneInputCommponent from "./commponents/phoneInput";
import CountryInput from "./commponents/country-input";
import React from "react";

function ThirdStep() {
  const [country, setCountry] = React.useState("sk");
  const { values, errors, handleChange, setErrors } =
    useContext<any>(FormContext);
  useEffect(() => {
    setErrors({ ...errors, email: "", phone: "", agreement: "" });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (errors.other) {
      setErrors({ ...errors, email: "", phone: "", agreement: "" });
    }
    // eslint-disable-next-line
  }, [errors && values]);
  const { t } = useTranslation();
  const gdprContent = t("signup__gdpr") || "";
  return (
    <div className="form-center1">
      <div className="registration1">
        <h1>{t("signup__contact_details")}</h1>
        <h2>{t("signup__know_you")}</h2>
        <div className="inputs">
          <label htmlFor="url " className="inputFieldSurname">
            {t("signup__labelURL")}
            <small style={{ color: "dimgray" }}>
              {" "}
              ({t("signup__optional")})
            </small>
          </label>
          <input
            pattern="^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$"
            aria-label="url"
            onChange={handleChange}
            name="url"
            value={values.url}
            id="url"
            type="text"
            className="surname"
          ></input>

          <CountryInput
            onChange={handleChange}
            value={values.country}
            setCountry={setCountry}
          />

          <label htmlFor="email" className="inputFieldEmail">
            {t("signup__labelEmail")}
          </label>
          <span className="errorEmail">{errors.email}</span>
          <input
            onChange={handleChange}
            value={values.email}
            className="email"
            type="email"
            name="email"
          />
          <label htmlFor="phone" className="inputFieldPhone">
            {t("signup__labelPhone")}
          </label>
          <div className="phone">
            <PhoneInputCommponent
              handleChange={handleChange}
              value={values.phone}
              country={country}
            />
          </div>

          <label className="errorPhone">{errors.phone}</label>

          <label className="gdprText">
            <span dangerouslySetInnerHTML={{ __html: gdprContent }} />
            <input
              onChange={handleChange}
              id="agreement"
              value={values.agreement}
              name="agreement"
              type="checkbox"
            />

            <span className="checkmark"></span>
          </label>
          <label className="errorGdpr">
            {errors.agreement}
            {errors.other &&
              errors.other.map((e: any) => (
                <label className="errorGdpr"> {String(Object.values(e))}</label>
              ))}
          </label>
        </div>
      </div>
    </div>
  );
}

export default ThirdStep;
